export enum ReactionEnum {
  LIKE = 'LIKE',
  COMMENT = 'COMMENT',
}
